import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
//import { makeStyles } from "@mui/styles";
import "../../Switcher.scss";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { getAdminCallActive } from "../../redux/actions/adminPortal_callActiveAction";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  getAdminBillingMinutes,
  getAdminTotalMinutes,
} from "../../redux/actions/adminPortal_minutesAction";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
const drawerWidth = 240;

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto", // Adjust row height to make it more compact
          },
        },
      },
      defaultProps: {
        density: "compact", // Set default density to compact
      },
    },
  },
});
function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

function AdminBillingMinut({ colorThem }) {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [tMinutes, setTMinutes] = useState(0);
  const [response, setResponse] = useState("");
  const [fromDate, setFromDate] = useState(dayjs().format("DD/MM/YYYY"));
  const [toDate, setToDate] = useState(dayjs().format("DD/MM/YYYY"));

  const handleFromDateChange = (date) => {
    if (dayjs(date, "DD/MM/YYYY", true).isValid()) {
      // Convert the selected date to the desired format before updating state
      setFromDate(dayjs(date).format("DD/MM/YYYY"));
    } else {
      setFromDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (dayjs(date, "DD/MM/YYYY", true).isValid()) {
      // Convert the selected date to the desired format before updating state
      setToDate(dayjs(date).format("DD/MM/YYYY"));
    } else {
      setToDate(null);
    }
  };
  useEffect(() => {
    let data = JSON.stringify({
      from_date: dayjs().format("YYYY-MM-DD"),
      to_date: dayjs().format("YYYY-MM-DD"),
    });
    // dispatch(getReport(data));
    // dispatch(getAllUsers(""));
  }, [dispatch, response]);

  const handleSearch = (e) => {
    // Convert fromDate and toDate to YYYY-MM-DD format
    e.preventDefault();
    const formattedFromDate = fromDate
      ? dayjs(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    const formattedToDate = toDate
      ? dayjs(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : null;
    let data = JSON.stringify({
      from_date: formattedFromDate,
      to_date: formattedToDate,
    });
    dispatch(getAdminTotalMinutes(data, setTMinutes));
  };

  const handleReset = (e) => {
    e.preventDefault();
    setTMinutes(0);
  };

  useEffect(() => {
    dispatch(getAdminBillingMinutes());
    dispatch(getAdminCallActive());
  }, []);

  const columns = [
    {
      field: "username",
      headerName: "Username",
      headerClassName: "custom-header",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      flex: 1,
    },
    {
      field: "monthly_minutes",
      headerName: "Monthly Usage Minutes",
      minWidth: 185,
      flex: 1,
      headerClassName: "custom-header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "total_billsec",
      headerName: "Bill Sec",
      minWidth: 150,
      flex: 1,
      headerClassName: "custom-header",
      headerAlign: "center",
      align: "center",
    },
  ];
  const rows = useMemo(() => {
    const calculatedRows = [];
    state?.getAdminBillingMinutes?.billingminutes &&
      state?.getAdminBillingMinutes?.billingminutes?.forEach((item, index) => {
        calculatedRows.push({
          id: index + 1,
          username: item?.username,
          monthly_minutes: item?.monthly_minutes,
          total_billsec: item?.total_billsec,
        });
      });
    return calculatedRows;
  }, [state?.getAdminBillingMinutes?.billingminutes]);

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <div className="col-lg-12">
              <div className="">
                {/* <!----> */}
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    {/* <!--role-contet--> */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: { xs: "space-between", md: "space-between" },
                        flexWrap: "wrap",
                        alignItems: "center",
                        flexDirection: { xs: "row", md: "row" },
                        textAlign: { xs: "left", md: "left" },
                        gap: { xs: 1, md: 0 },
                        width: "100%",
                      }}
                    >
                      {/* Title */}
                      <Box>
                        <Typography
                          sx={{
                            m: 0,
                            color: "#f5751D",
                            fontWeight: 500,
                            fontSize: { xs: "1.5rem", md: "2rem" }, // 🔥 Responsive font
                          }}
                        >
                          Usage Minutes
                        </Typography>
                      </Box>

                      {/* Total Used Minutes */}
                      <Typography
                        sx={{
                          fontSize: { xs: "15px", md: "17px" },
                          fontWeight: 600,
                          color: "rgb(66, 118, 95)",
                        }}
                      >
                        Total Used Minute:
                        <Box component="span" sx={{ fontWeight: 400, px: 0.5 }}>
                          {tMinutes}
                        </Box>
                      </Typography>
                    </Box>

                    <Grid
                      container
                      spacing={1}
                      sx={{
                        pb: 3,
                        mt: 1,
                        alignItems: "center",
                        justifyContent: { xs: "center", md: "space-between" },
                      }}
                    >
                      {/* Date Section */}
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display: "flex",
                          gap: 2,
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: { xs: "center", md: "flex-start" },
                        }}
                      >
                        {/* From Date */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="From Date"
                            value={
                              fromDate ? dayjs(fromDate, "DD/MM/YYYY") : null
                            }
                            onChange={handleFromDateChange}
                            format="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                fullWidth: true,
                              },
                            }}
                          />
                        </LocalizationProvider>

                        {/* To Date */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="To Date"
                            value={toDate ? dayjs(toDate, "DD/MM/YYYY") : null}
                            onChange={handleToDateChange}
                            format="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                fullWidth: true,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      {/* Button Section */}
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                          display: "flex",
                          justifyContent: { xs: "flex-end", md: "flex-end", },
                          mt: { xs: 1, md: 0 },
                        }}
                      >
                        <IconButton
                          className="filter_search_btn"
                          style={{
                            marginLeft: "0 !important",
                            background: "green !important",
                          }}
                          onClick={handleSearch}
                        >
                          {" "}
                          Search &nbsp; <SearchIcon />{" "}
                        </IconButton>{" "}
                        <IconButton
                          className="filter_reset_btn"
                          style={{
                            marginLeft: "0 !important",
                            backgroundColor: "grey !important",
                          }}
                          onClick={handleReset}
                        >
                          {" "}
                          Reset &nbsp; <RestartAltIcon />{" "}
                        </IconButton>

                      </Grid>
                    </Grid>

                    <div className="row">
                      <ThemeProvider theme={theme}>
                        <div style={{ height: "100%", width: "100%" }}>
                          <StyledDataGrid
                            // checkboxSelection
                            rows={rows}
                            columns={columns}
                            density="compact"
                            headerClassName="custom-header"
                            // getRowClassName={(params) =>
                            //   isRowBordered(params)
                            //     ? classes.borderedGreen
                            //     : classes.borderedRed
                            // }
                            components={{ Toolbar: GridToolbar }}
                            slots={{
                              toolbar: CustomToolbar,
                            }}
                            autoHeight
                          />
                        </div>
                      </ThemeProvider>
                    </div>
                  </div>

                  {/* <!----> */}
                  {/* 
            <!----> */}
                </div>
                {/* <!----> */}
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default AdminBillingMinut;
